@if (learnMode) {
  <app-screen-shell titleKey="learn.title" (back)="goBack()">
    <p>{{ 'learn.intro' | translate }}</p>
    @for (topic of learnTopics; track topic) {
      <section class="card mb-3"><div class="card-body">
        <h2>{{ ('learn.topics.' + topic + '.title') | translate }}</h2>
        <p><strong>{{ ('learn.topics.' + topic + '.lead') | translate }}</strong></p>
        <p>{{ ('learn.topics.' + topic + '.body') | translate }}</p>
        <button type="button" class="btn btn-primary" (click)="openTopic(topic)">{{ ('learn.topics.' + topic + '.action') | translate }}</button>
      </div></section>
    }
  </app-screen-shell>
} @else {
<app-screen-shell [contentClass]="'container'" titleKey="help.title" (back)="goBack()">
  <div class="row my-4 my-md-5">
    <div class="col col-md-10 mx-md-auto">
      <p><strong>{{ 'help.introLead' | translate }}</strong> {{ 'help.intro' | translate }}</p>
      <p>{{ 'help.support' | translate }} <a href="mailto:vedran.stanic@mangonel.hr">vedran.stanic&#64;mangonel.hr</a></p>

      <h3 class="text-center my-4 border-top pt-4">{{ 'help.menu.title' | translate }}</h3>
      <ul>@for (item of menuItems; track item) {
        <li>{{ ('help.menu.' + item) | translate }}</li>
      }</ul>

      <h3 class="text-center my-4 border-top pt-4">{{ 'help.player.title' | translate }}</h3>
      <ul>@for (item of playerItems; track item) {
        <li>{{ ('help.player.' + item) | translate }}</li>
      }</ul>

      <h3 class="text-center my-4 border-top pt-4">{{ 'help.manager.title' | translate }}</h3>
      <ul>@for (item of managerItems; track item) {
        <li>{{ ('help.manager.' + item) | translate }}</li>
      }</ul>

      <h3 class="text-center my-4 border-top pt-4">{{ 'help.roadmap.title' | translate }}</h3>
      <ul>
        @for (item of roadmapItems; track item) {
          <li>{{ ('help.roadmap.' + item) | translate }}</li>
        }
        <li>{{ 'help.roadmap.contact' | translate }} <a href="mailto:vedran.stanic@mangonel.hr">vedran.stanic&#64;mangonel.hr</a></li>
        <li>{{ 'help.roadmap.delete' | translate }} <a href="mailto:vedran.stanic@mangonel.hr">vedran.stanic&#64;mangonel.hr</a></li>
      </ul>
    </div>
  </div>
</app-screen-shell>

}
